import styled from "styled-components";

export const StyledPortalPage = styled.div`
  width: 100%;
  height: 100vh;
  font-family:
    ${(props) => props.theme["settings.general.font.family"]}, sans-serif;
  font-size: ${(props) => props.theme["settings.general.font.size"]}px;
`;

export const StyledPortalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.large};
  animation-name: fadeIn;
  animation-duration: 1s;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
